<template>
  <modal name="user-details" :classes="'customModal'" :scrollable="true" :reset="true" :adaptive="false" :width="1300"
    height="auto" @before-open="getData">
    <div class="modalWrapper">

      <!-- Permit Customer Details -->
      <div class="row">
        <div class="col-md-6">
          <div class="content__box mb-4">
            <div class="content__box__body">
              <h2 class="txt--fslg pb-1">
                {{
                    form.first_name +
                    " " +
                    form.last_name
                }}
              </h2>

              <div class="d-flex align-items-center flex-wrap">
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">Email</p>
                  <p class="txt--fsxs text-truncate">
                    {{ form.email }}
                  </p>
                </div>
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">Phone</p>
                  <p class="txt--fsxs text-truncate">
                    {{ form.phone || 'N/A' }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- Permits details -->
          <div class="content__box mb-4">
            <div class="content__box__header">
              <div class="top__filter align-items-center mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">
                    Permits
                  </li>
                </ul>
              </div>
              <div class="d-flex justify-content-around">
                <p class="txt--fsxs opacity--50 txt--semi-bold permit-cell">Id</p>
                <p class="txt--fsxs opacity--50 txt--semi-bold permit-cell">Name</p>
                <p class="txt--fsxs opacity--50 txt--semi-bold permit-cell-half">Status</p>
                <p class="txt--fsxs opacity--50 txt--semi-bold permit-cell-half">Sessions</p>
              </div>
              <div class="d-flex justify-content-around mt-2" v-for="(permit, index) in permit_list" :key="index">
                <p class="txt--fsxs text-truncate permit-cell">{{ permit.permit_id }}</p>
                <p class="txt--fsxs text-truncate permit-cell">{{ permit.permit_name }}</p>
                <p
                  :class="[
                    'txt--fsxs text-truncate',
                    'permit-cell-half',
                    permit.status == 'approved'
                      ? 'txt--green'
                      : 'txt--red',
                  ]"
                >
                  {{ permit.status }}
                </p>
                <p class="txt--fsxs opacity--50 text-truncate permit-cell-half cursor-pointer" @click="getSessions(permit.property_id)">Show</p>
              </div>
            </div>
          </div>
          <!-- Card details -->
          <div class="content__box mb-4">
            <div class="content__box__header">
              <div class="top__filter align-items-center mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">
                    Payment Details
                  </li>
                </ul>
              </div>
              <div class="d-flex flex-wrap mt-2" v-for="(card, index) in form.cards" :key="index">
                <div class="payment__card" v-if="card.brand != ''">
                  <img :src="getCreditcardLogo(card.brand)" alt="CardImage" />
                </div>
                <div class="payment__card" v-else>
                  <img src="@/assets/images/DebitCardImage/credit-card.png" alt="cardImage" />
                </div>
                <div class="modal__payment__text pl-3">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Type</p>
                    <p class="txt--fsxs opacity--50 pt-2 text-truncate">
                      Last 4
                    </p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">
                      {{ card.brand | capitalize }}
                    </p>
                    <p class="txt--fsxs pt-2 text-truncate">
                      {{ card.last4_digit }}
                    </p>
                  </div>
                </div>
                <div class="modal__payment__text pl-5">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Exp</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">
                      {{ card.exp_month + '/' + card.exp_year }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Vehicle details -->
          <div class="content__box mb-4">
            <div class="content__box__body">
              <div class="top__filter">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">
                    Vehicles
                  </li>
                </ul>
              </div>
              <div class="row pt-2 mt-2" v-for="(vehicle, index) in form.vehicles" :key="index">
                <div class="d-flex flex-wrap">
                  <div class="activity__indicator">
                    <div :class="[
                      vehicle.license_id != ''
                        ? 'sessions_number_box'
                        : 'sessions_number_box_long',
                      'text-center',
                    ]">
                      <div class="txt--xs txt--red txt--bold images_state">
                        {{ vehicle.state }}
                      </div>
                      <p class="txt--fsxs text-truncate txt--bold pt-1">
                        {{
                            vehicle.license_id != ""
                              ? vehicle.license_id
                              : vehicle.vin_id | capitalize
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text pl-3">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50 text-truncate">Year</p>
                      <p class="txt--fsxs opacity--50 pt-2 text-truncate">Make</p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate">
                        {{ (vehicle.vin_details || {}).ModelYear || 'N/A' }}
                      </p>
                      <p class="txt--fsxs pt-2 text-truncate">
                        {{ (vehicle.vin_details || {}).Make || 'N/A' }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text pl-5">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50 text-truncate">Model</p>
                      <p class="txt--fsxs opacity--50 pt-2 text-truncate">
                        Color
                      </p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate">
                        {{ (vehicle.vin_details || {}).Model || 'N/A' }}
                      </p>
                      <p class="txt--fsxs pt-2 text-truncate">
                        {{ (vehicle.vin_details || {}).Color || 'N/A' }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Permit Customer Session Details -->
        <div class="col-md-6 mt-4 mt-md-0">
          <div class="content__box content__box--activity" style="height: 100%">
            <div class="content__box__header pb-0">
              <div class="top__filter flex-nowrap align-items-center">
                <ul class="top__filter__ul">
                  <li>Sessions</li>
                </ul>
                <ul class="top__filter__ul search_form_control">
                  <li>
                    <input type="text" placeholder="Search license plate OR VIN" aria-label="Search"
                      class="form-control form-control-sm" v-model="session_search" />
                  </li>
                </ul>
                <ul class="top__filter__ul">
                  <li :class="{ 'active': session_type == 1 }" @click="changeSessionFilter(1)">Active</li>
                  <li :class="{ 'active': session_type == 2 }" @click="changeSessionFilter(2)">Past</li>
                </ul>
              </div>
            </div>
            <div class="content__divider"></div>
            <div id="session_div" class="
                content__box__body
                box__height box__height--session-property
              ">
              <div class="activity__list session__list" v-if="session_list.length > 0">
                <div v-for="(session, index) in session_list" :key="index">
                  <div :id="'session_' + index" class="activity__list session__list">
                    <div class="activity__new activity__new--property pb-0">
                      <div class="activity__indicator mb-2">

                        <div :class="[
                          session.vehicle_details.license_id != ''
                            ? 'sessions_number_box text-center'
                            : 'text-center sessions_number_box_vin',
                        ]">
                          <div class="txt--xs txt--red txt--bold images_state">
                            {{
                                session.vehicle_details.state_full_name !=
                                  ""
                                  ? session.vehicle_details
                                    .state_full_name
                                  : session.vehicle_details.license_id !=
                                    ""
                                    ? session.vehicle_details.country
                                    : ""
                            }}
                          </div>
                          <p class="txt--fsxs text-truncate txt--bold pt-1"
                            v-if="session.vehicle_details.license_id != ''">
                            {{
                                session.vehicle_details.license_id.toUpperCase()
                            }}
                          </p>
                          <p v-else class="txt--fsxs txt--bold pt-1">
                            {{
                                session.vehicle_details.vin_id
                                | last_eight(8, "##")
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="activity__txt activity__txt--property mb-2">
                        <div class="sessions_start_duration text-right mr-3">
                          <p class="txt--fsxs opacity--50 text-truncate">
                            Start
                          </p>
                          <p class="txt--fsxs opacity--50 pt-2 text-truncate">
                            Duration
                          </p>
                        </div>
                        <div class="activity__msg txt--semi-bold">
                          <p class="txt--fsxs text-truncate">
                            {{ session.booking_start_date_formatted }}
                          </p>
                          <p class="txt--fsxs pt-2 text-truncate">
                            {{ session.stay_duration }}
                            <span v-if="
                              session_type == 2 &&
                              session.booking_type != 'anonymous' &&
                              session.customer_type != 2
                            " class="pl-2">
                              {{
                                  "$" +
                                  session.price_breakdown.payable_amount
                              }}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="
                          activity__address activity__address--property
                          mb-2
                        ">
                        <p class="txt--xs opacity--50 text-truncate">
                          {{
                              session.property_name != ""
                                ? session.property_name
                                : session.display_address
                          }}
                        </p>
                        <p class="txt--xs opacity--50 text-truncate pt-2">
                          {{ session.customer_type_name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <infinite-loading @infinite="paginateSession" :distance="10" v-if="
                  session_list.length > 0 &&
                  session_load_more
                ">
                  <div slot="spinner">
                    <div class="d-flex justify-content-center mt-4">
                      <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div slot="no-more"></div>
                  <div slot="no-results">No data found</div>
                </infinite-loading>
              </div>
              <div v-if="session_list.length == 0 && session_loader" class="
                  d-flex
                  justify-content-center
                  reports__details--body
                  m-customer--min-height
                ">
                <div class="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Close Modal Cross Icon -->
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  name: "UserDetails",
  data() {
    return {
      status: 0,
      form: {
        id: "",
        first_name: "",
        last_name: "",
        email: "",
        cards: [],
        vehicles: []
      },
      permit_list: [],

      session_source: null,
      session_list: [],
      session_page: 1,
      session_loader: false,
      session_load_more: false,
      session_search: '',
      session_type: 1,
    };
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        document.addEventListener("click", handler);
      },

      unbind: function (el, binding) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  filters: {
    capitalize: function (text) {
      return text.toUpperCase();
    },
    titleCase: function (text) {
      return this.titleCase(text);
    },
    truncate: function (text, length, suffix) {
      let text_ar = text.split("/");
      text = text_ar[text_ar.length - 1];
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        let text_arr = text.split(".csv");
        text = text_arr[0] + ".";
        return text;
      }
    },
  },
  watch: {
    session_search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.getSessions();
      }
    },
  },
  methods: {
    titleCase: function (text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    getData(e) {
      this.form = {
        id: e.params.user.user_id,
        first_name: e.params.user.first_name,
        last_name: e.params.user.last_name,
        email: e.params.user.email,
        cards: e.params.user.cards,
        vehicles: e.params.user.vehicles
      };
      this.permit_list = e.params.user.permits;
    },
    closeModal() {
      this.$modal.hide("permit-customer");
    },
    getSessions(property_id) {
      if (this.session_source) {
        this.session_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_source = CancelToken.source();
      this.session_loader = true;
      this.session_page = 1;
      this.session_list = [];
      this.session_load_more = false;

      this.axios
        .post(
          window.hostname + "/api/auth/booking",
          {
            page: this.session_page,
            space_id: property_id,
            mode: "show-booking",
            booking_for: "owner",
            booking_type: 1,
            session_type: this.session_type,
            filter: 0,
            search_param: this.session_search,
            booking_user_id: this.form.id,
            time_zone: this.$moment.tz.guess(new Date()),
            start_date: "",
            end_date: "",
          },
          {
            cancelToken: this.session_source.token,
          }
        )
        .then(res => {
          this.session_loader = false;
          if (res.data.status) {
            this.session_list = res.data.data.booking_details;
            this.session_page++;
            this.session_load_more = res.data.data.pagination.load_more == 1 ? true : false;
          }
          else {
            this.session_load_more = false;
            this.session_list = [];
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch(err => {
          this.session_list = [];
          this.session_loader = false;
          this.session_load_more = false;
        });
    },
    paginateSession($state) {
      if (this.session_source) {
        this.session_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/booking",
          {
            page: this.session_page,
            space_id: this.property_id,
            mode: "show-booking",
            booking_for: "owner",
            booking_type: 1,
            session_type: this.session_type,
            filter: 0,
            search_param: this.session_search,
            booking_user_id: this.form.id,
            time_zone: this.$moment.tz.guess(new Date()),
            start_date: "",
            end_date: "",
          },
          {
            cancelToken: this.session_source.token,
          }
        )
        .then(res => {
          this.session_loader = false;
          if (res.data.status) {
            let session_list = res.data.data.booking_details;
            session_list.map(val => {
              this.session_list.push(val);
            });

            this.session_page++;
            this.session_load_more = res.data.data.pagination.load_more == 1 ? true : false;

            if (this.session_load_more) {
              $state.loaded();
            }
            else {
              $state.complete();
            }
          }
          else {
            this.session_load_more = false;
            this.session_list = [];
            $state.complete();
          }
        })
        .catch(err => {
          $state.error();
          this.session_list = [];
          this.session_loader = false;
          this.session_load_more = false;
        });
    },
    changeSessionFilter(filter) {
      this.session_type = filter;
      this.getSessions();
    },
    getCreditcardLogo(card) {
      var image = require("@/assets/images/DebitCardImage/credit-card.png");
      try {
        image = require("@/assets/images/DebitCardImage/" + card + ".png");
      } catch (e) {
        image = require("@/assets/images/DebitCardImage/credit-card.png");
      }
      return image;
    },
  },
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}

select option {
  background: #121212;
  border: none;
  margin: 40px;
}

.sessions_number_box_long {
  background-color: var(--primaryWhite);
  border-radius: 3px;
  padding: 6px 8px;
  cursor: pointer;
  /* width: 125px; */
  color: black;
  cursor: default;
}

.permit-cell {
  width: 100%;
  text-align: center;
}

.permit-cell-half {
  width: 50%;
  text-align: center;
}

</style>
